import { Injectable } from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {TransferQuotesDialogComponent} from '../../quotes/transfer-quotes-dialog/transfer-quotes-dialog.component';
import {QuotesDialogComponent} from '../../quotes/quotes-dialog/quotes-dialog.component';
import {ASSIGNMENTS} from './endpoints';
import {BaseService} from './base.service';
import {HttpClient} from '@angular/common/http';
import { IWGSharedService } from './shared.service';

@Injectable({
  providedIn: 'root'
})
export class QuoteDialogService extends BaseService {

  constructor(
      private dialog: MatDialog,
      http: HttpClient,
      private sharedService:IWGSharedService
  ) { super(http); }

  show = (ev, quoteId, evaluationId, serviceId, isEditFromDetails) => {
    if (quoteId) {
      const url = ASSIGNMENTS + '?id=' + quoteId;
      return this.getRequest(url, null).subscribe((quote: any) => {
        this.showDialog(ev, quote.data.Data, evaluationId, serviceId, isEditFromDetails, false, null);
      });
    } else {
      this.showDialog(ev, null, evaluationId, serviceId, isEditFromDetails, false, null);
    }
  }

  showTransferEOR = (ev, assignmentId, serviceId) => {
    if (assignmentId) {
      const url = ASSIGNMENTS + '?id=' + assignmentId;
      return this.getRequest(url, null).subscribe((existingAssignment: any) => {        
        this.showDialog(ev, null, assignmentId, serviceId, false, true, existingAssignment.data.Data);
        //this.showTransferEorQuoteDialog(ev, existingAssignment.data.Data, assignmentId, serviceId);
      });
    }
  }

  showDialog(ev, quote, evaluationId, serviceId, isEditFromDetails, isTransferToEOR, existingAssignment) {
    this.sharedService.isBlurredBg.next(true);
    const dialogRef = this.dialog.open(QuotesDialogComponent, {
      panelClass: ['iwg-form-dialogfull'], maxWidth: '100%',
      data : {
        existingQuote: quote,
        existingEvaluationId: evaluationId,
        existingServiceId: serviceId,
        isEditFromDetails,
        isTransferToEOR,
        existingAssignment
      }
    });
    console.warn("QuotesDialogComponent");
    dialogRef.afterClosed().subscribe(result => {
      this.sharedService.isBlurredBg.next(false);      
    });
  }

  showTransferEorQuoteDialog(ev, existingAssignment, assignmentId, serviceId) {
    this.sharedService.isBlurredBg.next(true);
    const dialogRef = this.dialog.open(TransferQuotesDialogComponent, {
      panelClass: ['iwg-form-dialogfull'], maxWidth: '100%',
      data : {
        existingAssignment,
        existingEvaluationId: assignmentId,
        existingServiceId: serviceId
      }
    });
    console.warn("TransferQuotesDialogComponent");
    dialogRef.afterClosed().subscribe(result => {
      this.sharedService.isBlurredBg.next(false);      
    });
  }
}
